import { axios } from "src/common/utils";
import authHeader from "src/common/auth/authHeader";

const EvaluationService = {};

EvaluationService.GridData = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GridESGData`,
      data: {
        version: data.version,
        evaluationName: data.evaluationName,
        startDate: data.startDate,
        endDate: data.endDate,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GridDataReport = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GridESGDataReport`,
      data: {
        version: data.version,
        evaluationName: data.evaluationName,
        startDate: data.startDate,
        endDate: data.endDate,
        isActive: data.isActive,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.ddlVersion = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/DdlVersion`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
EvaluationService.GetEvaFormData1 = (id) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetEvaFormData1`,
      data: {
        ID: id,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.SaveEvaForm1 = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/SaveEvaForm1`,
      data: {
        mainVersionID: data.mainVersionID,
        versionName: data.versionName,
        subVersionID: data.subVersionID,
        oldSubVersionID: data.oldSubVersionID,
        startDate: data.startDate,
        endDate: data.endDate,
        minScore: data.minScore,
        totalScoreWeight: data.totalScoreWeight,
        esgFormNameTH: data.esgFormNameTH,
        esgFormNameEN: data.esgFormNameEN,
        esgFormDetailTH: data.esgFormDetailTH,
        esgFormDetailEN: data.esgFormDetailEN,
        statusForm: data.statusForm,
        actionBy: data.actionBy,
        sectionList: data.sectionList,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GetEvaFormData1 = (id) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetEvaFormData1`,
      data: {
        ID: id,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GetSectionData = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetSectionData`,
      data: {
        MainVersionId: data.MainVersionId,
        SubVersionId: data.SubVersionId,
        SectionId: data.SectionId,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GetQuestionData = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetQuestionData`,
      data: {
        MainVersionId: data.MainVersionId,
        SubVersionId: data.SubVersionId,
        SectionId: data.SectionId,
        SubSectionId: data.SubSectionId,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.SaveEvaForm2SubSection = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/SaveEvaForm2SubSection`,
      data: data,
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.SaveEvaForm2Question = (data) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("MainVersionId", data.MainVersionId);
    formData.append("SubVersionId", data.SubVersionId);
    formData.append("statusForm", data.statusForm);
    formData.append("startDate", data.startDate);
    formData.append("endDate", data.endDate);
    formData.append("SectionId", data.SectionId);
    formData.append("EsgSectionNameTh", data.EsgSectionNameTh);
    formData.append("EsgSectionNameEn", data.EsgSectionNameEn);

    for (let i = 0; i < data.fileList.length; i++) {
      formData.append("files", data.fileList[i]);
    }

    formData.append("QuestionListJSON", JSON.stringify(data.QuestionList));

    axios({
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/SaveEvaForm2Question`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.SaveEvaForm3 = (data) => {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("MainVersionId", data.MainVersionId);
    formData.append("SubVersionId", data.SubVersionId);
    formData.append("statusForm", data.statusForm);
    formData.append("startDate", data.startDate);
    formData.append("endDate", data.endDate);
    formData.append("SectionId", data.SectionId);
    formData.append("SubSectionId", data.SubSectionId);
    formData.append("EsgSectionNameTh", data.EsgSectionNameTh);
    formData.append("EsgSectionNameEn", data.EsgSectionNameEn);
    formData.append("esgSubSectionNameTh", data.esgSubSectionNameTh);
    formData.append("esgSubSectionNameEn", data.esgSubSectionNameEn);

    for (let i = 0; i < data.fileList.length; i++) {
      formData.append("files", data.fileList[i]);
    }

    formData.append("QuestionListJSON", JSON.stringify(data.QuestionList));

    axios({
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/SaveEvaForm3`,
      data: formData,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GetMasterAnswer = () => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "get",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetMasterAnswer`,
      data: {},
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.ConfirmPublishForm = (id, startDate) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/ConfirmPublishForm`,
      data: {
        ID: id,
        startDate: startDate,
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GetReportChartData = (id) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetReportChartData`,
      data: {
        vendorRegisID: id,
        chart1Base64: "",
        chart2Base64: "",
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GetReport = (id, url1, url2) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetReport`,
      method: "post",
      data: {
        vendorRegisID: id,
        chart1Base64: url1,
        chart2Base64: url2,
      },
      responseType: "blob",
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.GetEvaFormExcelExport = (data) => {
  return new Promise((resolve, reject) => {
    axios({
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/GetEvaFormExcelExport`,
      method: "post",
      data: {
        ID: data,
      },
      responseType: "blob",
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};

EvaluationService.DeleteSubSectionBySectionId = (MainVersionId,SubVersionId,SectionId) => {
  return new Promise((resolve, reject) => {
    axios({
      headers: authHeader(),
      method: "post",
      url: `${process.env.REACT_APP_ESG_SERVICE}/api/EvaluationESG/DeleteSubSectionBySectionId`,
      data: {
        MainVersionId: MainVersionId,
        SubVersionId: SubVersionId,
        SectionId: SectionId
      },
    })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });
};
export default EvaluationService;
